import type { CanceledError } from "axios";

/** Parsed Problem Details fields; nullable/malformed wire values are omitted. Never render these directly. */
export interface ProblemDetails {
  type?: string;
  title?: string;
  detail?: string;
  instance?: string;
}

/** Transport failure with a numeric HTTP status independent of the response body. */
export class ApiError extends Error {
  constructor(
    public readonly kind:
      "http" | "network" | "timeout" | "invalid-response" | "unexpected",
    public readonly status: number | null = null,
    public readonly problem?: ProblemDetails,
  ) {
    // Do not retain Axios config, credentials, or arbitrary response bodies in the error message.
    super(`API ${kind} failure${status === null ? "" : ` (${status})`}`);
    this.name = "ApiError";
  }
}

/** Cancellation remains distinguishable and is never converted into a user-facing HTTP failure. */
export type ApiFailure = ApiError | CanceledError<unknown>;
